import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InnovationsubheadingListComponent } from './innovationsubheading-list/innovationsubheading-list.component';
import { InnovationsubheadingCreateComponent } from './innovationsubheading-create/innovationsubheading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InnovationsubheadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: InnovationsubheadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'innovation-subheading-create/:id',
        component: InnovationsubheadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InnovationSubHeadingRoutingModule { }
